export interface RegistriRequest {
  registroTipoId?: string;
  filtro: RegistriRequestFiltro;
  documentoId?: number;
  dataInizio?: Date;
  dataFine?: Date;
  numeroOrdineInizio?: number;
  numeroOrdineFine?: number;
}

export enum RegistriRequestFiltro {
  byDocumentoId = 1,
  byData = 2,
  byNumeroOrdine = 3
}

export interface RegistroProtocollo {
  registroData: string;
  documentoId: number;
  numeroOrdine: number;
  progressivo: string;
  arrPart: string;
  mittDest: string | null;
  dataNumeroAtto: string | null;
  oggetto: string | null;
  posizioneArchivio: string | null;
  annotazioni: string | null;
  annullato: boolean;
}
export interface RegistroRiproduzioni {
  documentoId: number;
  numeroOrdine: number;
  numeroRichiesta: number;
  dataRichiesta: string;
  richiedente: string;
  protocollo: string;
  dataProtocollazione: string;
  qualificaClassifica: string;
  numeroPagine: number;
  numeroCopie: string;
  distrutta: boolean;
  annotazioni: string;
  funzionarioDiControllo: string;
}
export interface RegistroUnico {
  numeroOrdine: number;
  classificaQualifica: string;
  dataProtocollazione: string;
  lingua: string;
  numeroCopie: number;
  distribuzione: string;
  posizioneArchivio: string;
}
export interface RegistroCarico {
  documentoId: number;
  numeroOrdine: number;
  numeroDiControllo: number;
  protocollo: string;
  classifica: string;
  dataProtocollazione: string;
  lingua: string;
  numeroEsemplari: string;
  numeroCopia: number;
  allegati: string;
  distribuzione: string;
  copieInCarico: string;
  variazioni: string;
  note: string;
}
export interface RegistroDistruzioni {
  documentoId: number;
  numeroOrdine: number;
  registroData: string;
  classificaQualifica: string;
  note: string;
}

export interface RegistroAllegatiCIS {
  numeroOrdine: number;
  registroData: Date;
  documentoId: number;
  tipoCIS: string;
  classifica: string;
  caricoRicevente: string;
  caricoDataProtocollazione?: Date;
  caricoFirma: string;
  restituzioneData?: Date;
  restituzioneFirma: string;
  distruzioneData?: Date;
  distruzioneFirma: string;
  note: string;
  annotazioni: string;
  annotazioniUtente: string;
}
export type RegistroGenerico = RegistroProtocollo | RegistroRiproduzioni | RegistroUnico | RegistroCarico | RegistroDistruzioni | RegistroAllegatiCIS;

export interface TipoRegistro {
  tipo: string;
  categoria: string;
}

export interface QualificaRegistro {
  qualifica: string;
}

export interface RegistroCategoria {
  registroCategoriaId: string;
  nome: string;
  registroTipo: RegistroTipo[];
}

export interface RegistroTipo {
  registroTipoId: string;
  nome: string;
}

export interface RegistriResponse {
  carico: RegistroCarico[];
  cis: RegistroAllegatiCIS[];
  distruzioni: RegistroDistruzioni[];
  protocollo: RegistroProtocollo[];
  riproduzioni: RegistroRiproduzioni[];
  controllo: RegistroUnico[];
}
